import React from 'react';

/**
 * Shared KPI card used across Uren Overzicht, Verloning and Dashboard.
 */
export function KpiTile({ icon: Icon, label, value, sublabel, accent }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-wider text-slate-500">{label}</p>
          <p
            className="mt-1 text-2xl font-bold tabular-nums text-slate-900"
            data-testid={`kpi-${label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {value}
          </p>
          {sublabel && <p className="mt-0.5 text-[11px] text-slate-500">{sublabel}</p>}
        </div>
        <div
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
            accent || 'bg-brand-amber/15 text-brand-amber-dark'
          }`}
        >
          <Icon size={16} />
        </div>
      </div>
    </div>
  );
}
